import { render, staticRenderFns } from "./editorPhotos.component.vue?vue&type=template&id=0ddcd552&scoped=true&"
import script from "./editorPhotos.component.vue?vue&type=script&lang=js&"
export * from "./editorPhotos.component.vue?vue&type=script&lang=js&"
import style0 from "./editorPhotos.component.vue?vue&type=style&index=0&id=0ddcd552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddcd552",
  null
  
)

export default component.exports